export default {"src":"/_next/static/media/Maryland.faec8f9a.svg","height":326,"width":800,"blurWidth":0,"blurHeight":0};